module.exports = __webpack_public_path__ + "static/media/page-banner.91ffaa2e.jpg";